import { useState, useEffect, useCallback } from "react";
import { apiFetch } from "../utils/api";

let globalFavIds: Set<string> = new Set();
let globalListeners: Array<() => void> = [];
let loaded = false;
let loading = false;

function notify() {
  globalListeners.forEach((fn) => fn());
}

async function loadFavorites() {
  const token = localStorage.getItem("broker_token");
  if (!token) {
    globalFavIds = new Set();
    loaded = true;
    notify();
    return;
  }
  if (loading) return;
  loading = true;
  try {
    const res = await apiFetch<{ ids: string[] }>("/api/favorites");
    globalFavIds = new Set(res.ids);
    loaded = true;
  } catch {
    globalFavIds = new Set();
    loaded = true;
  } finally {
    loading = false;
    notify();
  }
}

export function useFavorites() {
  const [, setTick] = useState(0);

  useEffect(() => {
    const listener = () => setTick((t) => t + 1);
    globalListeners.push(listener);

    if (!loaded && !loading) {
      loadFavorites();
    }

    return () => {
      globalListeners = globalListeners.filter((fn) => fn !== listener);
    };
  }, []);

  const isFav = useCallback((id: string) => globalFavIds.has(id), []);

  const toggle = useCallback(async (listingId: string) => {
    const token = localStorage.getItem("broker_token");
    if (!token) {
      alert("\uB85C\uADF8\uC778 \uD6C4 \uC774\uC6A9 \uAC00\uB2A5\uD569\uB2C8\uB2E4");
      return;
    }

    const wasFav = globalFavIds.has(listingId);

    // Optimistic update
    if (wasFav) {
      globalFavIds.delete(listingId);
    } else {
      globalFavIds.add(listingId);
    }
    notify();

    try {
      if (wasFav) {
        await apiFetch(`/api/favorites/${listingId}`, { method: "DELETE" });
      } else {
        await apiFetch(`/api/favorites/${listingId}`, { method: "POST" });
      }
    } catch {
      // Rollback on error
      if (wasFav) {
        globalFavIds.add(listingId);
      } else {
        globalFavIds.delete(listingId);
      }
      notify();
    }
  }, []);

  return { favIds: globalFavIds, isFav, toggle };
}

/** Reset favorites cache (call on logout) */
export function resetFavorites() {
  globalFavIds = new Set();
  loaded = false;
  loading = false;
  notify();
}
